<template>
  <div style="padding-left:10px">
    <span>
      <div style="float:left;width:150px;margin-right:15px">{{parameter.Name}}:</div>
      <div v-bind:style="voltageStyle">{{parameter.Actual}}</div>
    </span>
  </div>
</template>

<script>
export default {
  components: {
  },

  props: {
    parameter: Object,
  },

  computed: {
    voltageStyle() {
      if (
        this.parameter.Actual >= this.parameter.Min
        && this.parameter.Actual <= this.parameter.Max
      ) {
        return 'color:green;';
      }

      return 'color:red;';
    },
  },

  methods: {

  },
};
</script>
